import React, { SVGProps } from 'react';
import styled from 'styled-components';

export interface CheckedIconProps extends SVGProps<{}> {
  width?: string;
  height?: string;
  color?: string;
}

const StyledSVG = styled.svg`
  .a {
    fill: ${props => props.color};
  }
  .b {
    clip-path: url(#a);
  }
`;

const CheckedIcon: React.FC<CheckedIconProps> = (props): JSX.Element => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 47.454 47.454"
      color={props.color}
    >
      <defs>
        <clipPath id="a">
          <path
            className="a"
            d="M23.727,3.454A23.727,23.727,0,0,1,0-20.273,23.727,23.727,0,0,1,23.727-44,23.727,23.727,0,0,1,47.454-20.273,23.727,23.727,0,0,1,23.727,3.454Zm0-4.314A19.413,19.413,0,0,0,43.14-20.273,19.413,19.413,0,0,0,23.727-39.686,19.413,19.413,0,0,0,4.314-20.273,19.413,19.413,0,0,0,23.727-.86ZM15.546-21.8l4.946,4.946L31.909-28.269a2.157,2.157,0,0,1,3.024.026,2.157,2.157,0,0,1,.026,3.024L22.017-12.277a2.157,2.157,0,0,1-3.05,0L12.5-18.748a2.157,2.157,0,0,1,.026-3.024A2.157,2.157,0,0,1,15.546-21.8Z"
            transform="translate(0 44)"
          />
        </clipPath>
      </defs>
      <g className="b" transform="translate(0 0)">
        <path
          className="a"
          d="M-5-49H53.239V9.239H-5Z"
          transform="translate(-0.393 43.607)"
        />
      </g>
    </StyledSVG>
  );
};

CheckedIcon.defaultProps = {
  width: '24px',
  height: '24px',
};

export default CheckedIcon;
